import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  patientAssessmentHistoryAsync,
  patientAssessmentAsync,
  ne1updateassessmentsignlockAsync,
  setAssessmentHistory,
  createNewParentFromChild,
  setDetailAssessment,
  setWoundAssessment,
  getConsolidatePdfAsync,
  setConsolidatePdfStatus,
} from "../../../../../app/patientSlice";
import { usePermissions } from "../../../../../hooks/usePermissions";
import { PERMISSIONS } from "../../../../../constants/permissions";
import { setDeleteAdminChildStatus } from "../../../../../app/appSlice";
import { assessmentStageGetterMove, handleDeleteData, openDeleteConfirmationData } from "../../../../../utils";
import { CONSOLIDATE_PDF_MAX_COUNT, DEFAULT_ASSESSMENT_LIMIT_OFFSET } from "../../../../../constants";
import { useLoading } from "../../../../../hooks/useLoading";
import { LOADING_KEYS } from "../../../../../constants/loadingKeys";

export const useAssessmentHistory = ({
  modalTitlteId,
  setmodalShow,
  deleteAssessment,
  deleteHistoryAssessment,
  childLevelDelete,
  setChildLevelDelete,
  setNewWoundOptionChildLevel,
  modalType,
}) => {
  const { hasPermission } = usePermissions();
  const { patientId } = useParams();
  const assessmentId = modalTitlteId;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loading = useLoading(LOADING_KEYS.GET_ASSESSMENT_HISTORY);
  const consolidatePdfLoading = useLoading(LOADING_KEYS.GET_CONSOLIDATE_PDF);

  const assessmnetHistoryData = useSelector((state) => state.patient.assessmentHistory);
  const childAsItsOwnParentAssessment = useSelector((state) => state.patient.childAsItsOwnParent);
  const patientData = useSelector((state) => state.patient.detailViewData);
  const consolidatePdfStatus = useSelector((state) => state.patient.consolidatePdfStatus);
  const historyCause = useSelector((state) => state.patient.historyCause);
  const woundProgress = useSelector((state) => state.patient.woundProgress);
  const deleteAdminChildStatus = useSelector((state) => state.app.deleteAdminChildStatus);
  const detailAssessment = useSelector((state) => state.patient.detailAssessment);
  const hasAccess = hasPermission(PERMISSIONS.ASSESSMENT_THREE_DOT_MENU);

  const [selectedIdsByWound, setSelectedIdsByWound] = useState({});

  // click on three dots action
  const [historyId, setHistoryId] = useState(); // PDf Popup Getting ID from assessment history list
  const [clickThreeDots, setClickThreeDots] = useState("");
  const [openTooltip, setOpenTooltip] = useState(false);
  const [assessmentIdValue, setAssessmentId] = useState();
  const [historyAssessmentId, setHistoryAssessmentId] = useState();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [assessTitleContent, setAssessTitleContent] = useState("");
  const [hoverUnlockIcon, setHoverUnlockIcon] = useState(false);
  const [hoverMergeIcon, setHoverMergeIcon] = useState(false);
  const [hoverTransferIcon, setHoverTransferIcon] = useState(false);
  const [hoverDeleteIcon, setHoverDeleteIcon] = useState(false);
  const [hoverNewWound, setHoverNewWound] = useState(false);
  const [lockUnlockToggle, setLockUnlockToggle] = useState(false);
  const [lockUnlockToggleLockedOne, setLockUnlockToggleLockedOne] = useState(false);
  const [lockUnlockToggleLockedZero, setLockUnlockToggleLockedZero] = useState(false);
  const [lockUnlockToggleLockedOnePopup, setLockUnlockToggleLockedOnePopup] = useState(false);
  const [lockUnlockToggleLockedZeroPopup, setLockUnlockToggleLockedZeroPopup] = useState(false);
  const [lockUnlockDone, setLockUnlockDone] = useState(false);
  const [getObject, setGetObject] = useState({});
  const [toggleClicked, setToggleClicked] = useState(false);
  const [latestReEval, setLatestReEval] = useState(false);
  const [lockUnlockToastMsg, setLockUnlockToastMsg] = useState(false);
  const [onNewWoundCreateConfirm, setOnNewWoundCreateConfirm] = useState(false);
  const [onNewWoundCreateId, setOnNewWoundCreateId] = useState();

  useEffect(() => {
    dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
  }, [patientId, assessmentId, dispatch]);

  useEffect(() => {
    setHoverUnlockIcon(false);
    setShowDeleteConfirmation(false);
    setClickThreeDots("");
    setOpenTooltip(false);
    setHoverUnlockIcon(false);
    setHoverMergeIcon(false);
    setHoverDeleteIcon(false);
    setLockUnlockToggle(false);
    setLockUnlockToggleLockedOne(false);
    setLockUnlockToggleLockedZero(false);
    setLockUnlockDone(false);
    setLockUnlockToggleLockedZeroPopup(false);
    setLockUnlockToggleLockedOnePopup(false);
    if (hasAccess) {
      setNewWoundOptionChildLevel(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (consolidatePdfStatus === "success") {
      setConsolidatePdfStatus("");
    }
    setTimeout(() => {
      dispatch(setConsolidatePdfStatus(""));
    }, 2500);
  }, [consolidatePdfStatus, dispatch]);

  // Delete assessment id after confirmation message purpose
  useEffect(() => {
    if (deleteAdminChildStatus && childLevelDelete) {
      loadOffAssessmentDelete();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteAdminChildStatus, childLevelDelete]);

  const loadOffAssessmentDelete = () => {
    setTimeout(() => {
      setOpenTooltip(false);
      setClickThreeDots("");
      setHoverUnlockIcon(false);
      setHoverMergeIcon(false);
      setHoverDeleteIcon(false);
      dispatch(setDeleteAdminChildStatus(false));
      if (hasAccess) {
        setChildLevelDelete(false);
      }
    }, 5000);
  };

  const modalRefresh = () => {
    setmodalShow(false);
  };

  // redirect to assessment details screen fn
  const detaileView = (data) => {
    navigate("/patients/" + patientId + "/assessment/" + data);
    modalRefresh();
  };

  const assessmentStageGetter = (data) => {
    return assessmentStageGetterMove(data);
  };

  const threeDotPanelClick = (assessmentID) => {
    dispatch(setDetailAssessment({}));

    const assessmentExists =
      assessmnetHistoryData?.followuphistory?.some((history) => history?.assessments?.some((assessment) => assessment.id === assessmentID)) ?? false;

    if (assessmentExists) {
      setClickThreeDots(assessmentID);
      setOpenTooltip(true);
      setLockUnlockToggle(false);
      setLockUnlockToastMsg(false);
    }

    const hasLockedAssessment =
      assessmnetHistoryData?.followuphistory?.some((history) => history?.assessments?.some((assessment) => assessment.isLocked === 1)) ?? false;

    setLockUnlockToggleLockedOne(hasLockedAssessment);
    setLockUnlockToggleLockedZero(false);
  };

  // outside click on three dots action
  const wrapperRef = useRef(null);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickOutside = (event) => {
    const isOutside = !wrapperRef?.current?.contains(event.target);

    setLockUnlockToggle(false);

    if (isOutside) {
      setOpenTooltip(false);
      setClickThreeDots("");

      const hasLockedAssessment =
        assessmnetHistoryData?.followuphistory?.some((history) => history?.assessments?.some((assessment) => assessment?.isLocked === 1)) ?? false;

      setLockUnlockToggleLockedOne(hasLockedAssessment);
      setLockUnlockToggleLockedZero(false);
    } else {
      setOpenTooltip(true);
    }
  };

  // Delete Functionlaity for each assessment

  const openDeleteConfirmation = (_assessmentId, _historyAssessmentId, woundTitle) => {
    setAssessTitleContent(woundTitle);
    openDeleteConfirmationData(_assessmentId, _historyAssessmentId, setAssessmentId, setHistoryAssessmentId, setShowDeleteConfirmation);
  };

  const handleDelete = () => {
    handleDeleteData(
      historyAssessmentId,
      deleteHistoryAssessment,
      assessmentIdValue,
      deleteAssessment,
      setAssessmentId,
      setHistoryAssessmentId,
      setShowDeleteConfirmation
    );
  };

  useEffect(() => {
    const hasLockedAssessment =
      assessmnetHistoryData?.followuphistory?.some((history) => history?.assessments?.some((assessment) => assessment?.isLocked === 1)) ?? false;

    setLockUnlockToggleLockedOne(hasLockedAssessment);
    setLockUnlockToggleLockedZero(false);
  }, [assessmnetHistoryData]);

  // Lock/unlock functionality
  const changeLockUnlockLockedOnePopup = (assessmentid, lockValue, signValue) => {
    const payloadObj = {
      assessmentid: assessmentid,
      lockValue: lockValue,
      signValue: signValue,
      LUONE: true,
    };
    setGetObject(payloadObj);
    setLockUnlockToggleLockedOnePopup(true);
    setLockUnlockToggleLockedOne((prev) => !prev);
    setLockUnlockToggleLockedZeroPopup(false);
  };
  const changeLockUnlockLockedZeroPopup = (assessmentid, lockValue, signValue) => {
    const payloadObj = {
      assessmentid: assessmentid,
      lockValue: lockValue,
      signValue: signValue,
      LUONE: false,
    };
    setGetObject(payloadObj);
    setLockUnlockToggleLockedZeroPopup(true);
    setLockUnlockToggleLockedZero((prev) => !prev);
    setLockUnlockToggleLockedOnePopup(false);
  };

  const onClickToggleLockUnlock = () => {
    setToggleClicked(true);
  };

  const lockUnlockConfirmation = () => {
    let assessmentid = getObject.assessmentid;
    let lockValue = getObject.lockValue;
    let signValue = getObject.signValue;
    let latestReEvalId = parseInt(
      assessmnetHistoryData?.followuphistory?.map((data) => data?.assessments?.map((item) => item))?.map((ele) => ele[0]?.id)
    );
    if (getObject.LUONE === true) {
      changeLockUnlockLockedOne(assessmentid, lockValue, signValue);
      setToggleClicked(false);
      if (latestReEvalId === assessmentid) {
        setLatestReEval(true);
      }
      if (latestReEvalId !== assessmentid) {
        setLatestReEval(false);
      }
    }
    if (getObject.LUONE === false) {
      changeLockUnlockLockedZero(assessmentid, lockValue, signValue);
      setToggleClicked(false);
      if (latestReEvalId === assessmentid) {
        setLatestReEval(true);
      }
      if (latestReEvalId !== assessmentid) {
        setLatestReEval(false);
      }
    }
  };

  const changeLockUnlockLockedOne = (assessmentid, lockValue, signValue) => {
    let getLockValue = lockValue === 1 ? 0 : 1;
    dispatch(setAssessmentHistory({}));
    const assessment = { signed: signValue, locked: getLockValue };
    const assessmentId = assessmentid;
    let payload = {
      patientId,
      assessmentId,
      assessment,
    };
    dispatch(ne1updateassessmentsignlockAsync(payload)).then(() => {
      setLockUnlockDone(true);
    });
  };

  const changeLockUnlockLockedZero = (assessmentid, lockValue, signValue) => {
    let getLockValue = lockValue === 1 ? 0 : 1;
    dispatch(setAssessmentHistory({}));
    const assessment = { signed: signValue, locked: getLockValue };
    const assessmentId = assessmentid;
    let payload = {
      patientId,
      assessmentId,
      assessment,
    };
    dispatch(ne1updateassessmentsignlockAsync(payload)).then(() => {
      setLockUnlockDone(true);
    });
  };

  useEffect(() => {
    if (lockUnlockDone) {
      setLockUnlockToastMsg(false);
      setTimeout(() => {
        dispatch(patientAssessmentHistoryAsync(patientId, assessmentId));
        loadOffAssessment();
        setLockUnlockToastMsg(true);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lockUnlockDone]);

  const loadOffAssessment = () => {
    if (latestReEval) {
      dispatch(patientAssessmentAsync(patientId, DEFAULT_ASSESSMENT_LIMIT_OFFSET));
    }
    setTimeout(() => {
      setLockUnlockToastMsg(false);
      setOpenTooltip(false);
      setClickThreeDots("");
      setHoverUnlockIcon(false);
      setHoverMergeIcon(false);
      setHoverDeleteIcon(false);
      setLockUnlockToggle(false);
      setLockUnlockDone(false);
      setLockUnlockToggleLockedZero(false);
      setLockUnlockToggleLockedOne(false);
      setLockUnlockToggleLockedZeroPopup(false);
      setLockUnlockToggleLockedOnePopup(false);
    }, 3000);
  };

  // Merge functionality
  const onMergeChange = (valueId) => {
    let adminPage = false;
    navigate(`/patients/${patientId}/assessment/${valueId}/mergewoundassessment`, {
      state: adminPage,
    });
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset"));
  };

  // New create functionality

  const onNewWoundCreatePopup = (assessmentId) => {
    setOnNewWoundCreateConfirm(true);
    setOnNewWoundCreateId(assessmentId);
  };

  const onNewWoundCreate = () => {
    let payload = {
      patientId: patientId,
      assessmentId: `${onNewWoundCreateId}`,
    };
    setOnNewWoundCreateConfirm(false);
    dispatch(createNewParentFromChild(payload, modalType, navigate));
  };

  useEffect(() => {
    if (childAsItsOwnParentAssessment) {
      const finalArrValue = parseInt(
        assessmnetHistoryData?.followuphistory
          ?.map((data) => data?.assessments?.filter((item) => item.id !== assessmentId))
          ?.map((item) => item[0]?.id)
      );
      setTimeout(() => {
        dispatch(patientAssessmentHistoryAsync(patientId, finalArrValue));
        loadOffAssessmentNewWound();
      }, 300);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childAsItsOwnParentAssessment]);

  const loadOffAssessmentNewWound = () => {
    setTimeout(() => {
      if (assessmnetHistoryData?.followuphistory.length > 0) {
        setmodalShow(false);
        setNewWoundOptionChildLevel(true);
      }
    }, 1000);
  };

  const onTransferChange = (valueId) => {
    let adminPage = false;
    navigate(`/patients/${patientId}/assessment/${valueId}/transferwoundassessment`, {
      state: adminPage,
    });
    dispatch(setDetailAssessment({}));
    dispatch(setAssessmentHistory({}));
    dispatch(setWoundAssessment("reset"));
  };

  const getAllMatchingChildIds = (parentItem) =>
    parentItem?.assessments
      ?.filter((a) => ["signedlocked"].includes(a.assessmentStage))
      ?.map((a) => a.id)
      ?.slice(0, CONSOLIDATE_PDF_MAX_COUNT) || [];

  const handleSelectOne = (parentIndex, childId) => {
    setSelectedIdsByWound((prev) => {
      const prevIds = prev[parentIndex] || [];
      return {
        ...prev,
        [parentIndex]: prevIds.includes(childId) ? prevIds.filter((i) => i !== childId) : [...prevIds, childId],
      };
    });
  };

  const handleSelectAll = (parentIndex, parentItem) => {
    const allIds = getAllMatchingChildIds(parentItem);

    setSelectedIdsByWound((prev) => {
      const alreadySelected = prev[parentIndex]?.length === allIds.length;
      return {
        ...prev,
        [parentIndex]: alreadySelected ? [] : allIds,
      };
    });
  };

  const handleDownloadConsolidatePDF = (woundTitle, selectedIds) => {
    const match = woundTitle?.match(/#(\d+):/);
    const woundNumber = match ? parseInt(match[1], 10) : null;
    const payload = {
      Ne1Id: patientData?.ne1Id,
      WoundNumber: woundNumber,
      Assessmentid: selectedIds,
      facilityNumber: patientData?.facilityNumber,
    };

    dispatch(getConsolidatePdfAsync(payload));
  };

  return {
    // context
    loading,
    hasAccess,
    patientId,
    assessmnetHistoryData,
    patientData,
    consolidatePdfLoading,
    historyCause,
    woundProgress,
    deleteAdminChildStatus,
    detailAssessment,
    // state
    selectedIdsByWound,
    historyId,
    clickThreeDots,
    openTooltip,
    showDeleteConfirmation,
    assessTitleContent,
    hoverUnlockIcon,
    hoverMergeIcon,
    hoverTransferIcon,
    hoverDeleteIcon,
    hoverNewWound,
    lockUnlockToggle,
    lockUnlockToggleLockedOne,
    lockUnlockToggleLockedZero,
    lockUnlockToggleLockedOnePopup,
    lockUnlockToggleLockedZeroPopup,
    toggleClicked,
    lockUnlockToastMsg,
    onNewWoundCreateConfirm,
    wrapperRef,
    // setters needed directly by JSX
    setHoverUnlockIcon,
    setHoverMergeIcon,
    setHoverTransferIcon,
    setHoverDeleteIcon,
    setHoverNewWound,
    setShowDeleteConfirmation,
    setLockUnlockToggleLockedOnePopup,
    setLockUnlockToggleLockedZeroPopup,
    setOnNewWoundCreateConfirm,
    setHistoryId,
    // handlers
    modalRefresh,
    detaileView,
    assessmentStageGetter,
    threeDotPanelClick,
    openDeleteConfirmation,
    handleDelete,
    changeLockUnlockLockedOnePopup,
    changeLockUnlockLockedZeroPopup,
    onClickToggleLockUnlock,
    lockUnlockConfirmation,
    onMergeChange,
    onNewWoundCreatePopup,
    onNewWoundCreate,
    onTransferChange,
    getAllMatchingChildIds,
    handleSelectOne,
    handleSelectAll,
    handleDownloadConsolidatePDF,
  };
};
